import { render, staticRenderFns } from "./SuperScoreView.vue?vue&type=template&id=726b1289"
import script from "./SuperScoreView.vue?vue&type=script&lang=ts"
export * from "./SuperScoreView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports